import React from 'react'

import { Box } from '@material-ui/core'
import { FormContext, useForm } from 'react-hook-form'

import EmailStep from './components/EmailStep'
import TwoFactorAuthenticationStep from './components/TwoFactorAuthenticationStep'
import ProfileSetupStep from './components/ProfileSetupStep'
import RegistrationMethodStep from './components/RegistrationMethodStep'
import InvalidLinkScreen from './components/InvalidLinkScreen'

import useGuestJourney from 'hooks/useGuestJourney'

import { emailStepSchema, twoFactorAuthenticationStepSchema } from './schema'

export const PROFILE_SETUP_STEP_INDEX = 2
export const REGISTRATION_METHOD_STEP_INDEX = 3

const STEPS = [
  <EmailStep />,
  <TwoFactorAuthenticationStep />,
  <ProfileSetupStep />,
  <RegistrationMethodStep />,
]

const SCHEMAS = [
  emailStepSchema,
  twoFactorAuthenticationStepSchema,
  undefined,
  undefined,
]

const Journey = () => {
  const { activeStep, linkInvalid } = useGuestJourney()

  const formMethods = useForm({
    validationSchema: SCHEMAS[activeStep],
    defaultValues: { email: '', code: '' },
  })

  if (linkInvalid) return <InvalidLinkScreen />

  return (
    <Box width="100%">
      <FormContext {...formMethods}>{STEPS[activeStep]}</FormContext>
    </Box>
  )
}

export default Journey
